module.exports = __webpack_public_path__ + "static/media/reactlogo.d7837d34.png";